import { Box, Tab, Tabs } from '@mui/material'
import { TabPanel } from 'components/TabPanel'
import React, { useContext, useEffect, useState } from 'react'
import UserAccountForm from './AccountProfile/UserAccountForm'
import OrganizationForm from './Organizations/OrganizationForm'
import UsersForm from './OrganizationUsers/UsersForm'
import RunsForm from './Organizations/RunsForm'
import { AuthSessionContext } from 'api/AuthSession'
import { useNavigate, useParams } from 'react-router'

const a11yProps = (index) => ({
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
})

const UserAccount = () => {
    const navigate = useNavigate()
    const { IS_USER } = useContext(AuthSessionContext)
    const [value, setValue] = useState(0)
    const { menu } = useParams()

    const handleChange = (event, newValue) => {
        switch (newValue)
        {
            case 0:
                navigate({ pathname: '/account/user' }); break;
            case 1:
                navigate({ pathname: '/account/organization' }); break;
            case 2:
                navigate({ pathname: '/account/organization/users' }); break;
            case 3:
                navigate({ pathname: '/account/organization/runs'}); break;
            default:
                setValue(0);
        }

    }

    useEffect(() => {
        if (IS_USER) {
            setValue(0)
            navigate({ pathname: '/account/user' });
        }
    }, [IS_USER])
    
    useEffect(() => {
        switch (menu)
        {
            case 'user':
                setValue(0); break;
            case 'organization':
                setValue(1); break;
            case 'users':
                setValue(2); break;
            case 'runs':
                setValue(3); break;
            default:
                setValue(0);
        }
    }, [menu])

    return (
        <Box
            sx={{
                flexGrow: 1,
                bgcolor: 'background.paper',
                display: 'flex',
            }}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="user account tabs"
                sx={{ borderRight: 1, borderColor: 'divider', width: '200px' }}
            >
                <Tab label="User Account" {...a11yProps(0)} />
                <Tab label="Organization" {...a11yProps(1)} />
                {!IS_USER && (
                    <Tab label="Users" {...a11yProps(2)} />
                )}
                {!IS_USER && (
                    <Tab label="Runs" {...a11yProps(3)} />
                )}
            </Tabs>
            <TabPanel value={value} index={0}>
                <div className="d-flex">
                    <UserAccountForm />
                </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <div className='d-flex'>
                    <OrganizationForm />
                </div>
            </TabPanel>
            {!IS_USER && (
                <TabPanel value={value} index={2}>
                    <div className='d-flex'>
                        <UsersForm />
                    </div>
                </TabPanel>
            )}
            {!IS_USER && (
                <TabPanel value={value} index={3}>
                    <div className='d-flex'>
                        <RunsForm />
                    </div>
                </TabPanel>
            )}
        </Box>
    )
}

export default UserAccount
